//================================================================
//  Component: Fiscal Year Picker
//================================================================

//  Purpose: This is a dropdown component for selecting the fiscal year

//  Properties:
//  1. register: Register the input field to react-hook-form
//  2. errors: Error message for the input field

//  Example:
//  <FiscalYearPicker 
//    register={register}
//    errors={errors} 
//  ></FiscalYearPicker>

//================================================================

export default function FiscalYearPicker({
  register,
  errors
}) {

  /*------------------------------------------------------*/
  /*  Define Constants                                    */
  /*------------------------------------------------------*/

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec

  // Determine current financial year
  // Check if current month is > June and append either current year or next year
  const currentFY = currentMonth >= 6 ? currentYear + 1 : currentYear;

  // Generate fiscal years: last FY to next 5 FYs
  // Creates an array of 7 elements and for each index, calculates the year by 'currentFY' - 1 + 'lastFY'
  const fiscalYears = Array.from({ length: 7 }, (_, i) => currentFY - 1 + i);

  /*------------------------------------------------------*/
  /*  HTML                                                */
  /*------------------------------------------------------*/

  return (
    <div className='FormComponent-Row'>

      {/* Label */}
      <label className='font-medium mb-1'>
        Fiscal Year<span className='text-[#C4314B]'> *</span>
      </label>

      {/* Select Input Container */}
      <div className='flex items-center border border-gray-300 rounded-md px-3 py-2 w-[300px] bg-white'>

        <span className='mr-2 font-medium text-gray-600'>FY</span>

        <select
          className='flex-1 bg-transparent outline-none'
          {...register('fiscalyear', { required: 'This field is required' })}
        >
          <option hidden value=''>Select</option>

          {
            fiscalYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))
          }

        </select>

      </div>

      {/* Error Message */}
      {
        errors.fiscalyear && 
        <p className='text-sm text-[#DE0000] mt-1'>
          {errors.fiscalyear?.message}
        </p>
      }

    </div>
  );

  //------------------------------------------------------

};
